import { useConfigStore } from '~/store/useConfigStore'

export const useSeasonQuery = () => {
  const configStore = useConfigStore()
  const { defaultSeason } = storeToRefs(configStore)
  const seasonId = useRouteQuery<number>('season', defaultSeason.value?.id, { transform: Number })

  return {
    seasonId,
  }
}
